import { FLOW_MODES } from '@avanta/shared/constants/appointments';
import { useFetchSpecialities } from '@avanta/shared/hooks/useFetchSpecialities';
import { useFetchSpecialitiesByPsycho } from '@avanta/shared/hooks/useFetchSpecialitiesByPsycho';
import { type Center, type Speciality, type Treatment } from '@avanta/shared/types/appointments';
import { useFormContext } from 'react-hook-form';
import { useLocation } from 'react-router';
import {
  type AppointmentsReserveFormData,
  AppointmentsReservePayload,
} from 'pages/AppointmentsReserve/types';

export const useSpecialities = (): {
  specialities: Speciality[];
  treatments?: Treatment[];
  workCenters?: Center[];
  isLoading: boolean;
} => {
  const { watch } = useFormContext<AppointmentsReserveFormData>();
  const { state } = useLocation();
  const [patientId, psychologist, flow] = watch([
    AppointmentsReservePayload.patientId,
    AppointmentsReservePayload.psychologist,
    AppointmentsReservePayload.flow,
  ]);
  const isSearchFlow = flow === FLOW_MODES.search;
  const patientIdValue = isSearchFlow ? '' : (patientId ?? state?.patientId);
  const psychologistId = !isSearchFlow ? '' : (psychologist?.id ?? '');
  const patientQuery = useFetchSpecialities(patientIdValue);
  const psychoQuery = useFetchSpecialitiesByPsycho({ psychologistId, insurance: true });

  return flow === FLOW_MODES.search
    ? {
        specialities: psychoQuery.data?.specialities ?? [],
        treatments: psychoQuery.data?.treatments ?? [],
        workCenters: psychoQuery.data?.workCenters ?? [],
        isLoading: psychoQuery.isLoading,
      }
    : { specialities: patientQuery.data ?? [], isLoading: patientQuery.isLoading };
};
